import Plugins from "./Plugins.js";
export default {
  ...Plugins
};